<mapfre-modal
  [modalOptions]="paperlessModalOptions"
  [hideModal]="hideModal"
  (click)="hideOnClick()"
>
  <hr class="margin-bottom mb-2 no-margin-top" />
  <div class="modal-body">
    <div class="p-banner">
      <p class="title">
        Go paperless
      </p>
    </div>
    <div class="popup-content">
      <p class="sub-title">
        Keep your records and documents in a digital environment!
      </p>
      <ul>
        <li>
          <ng-container *ngIf="isAcmic; else maIcon">
            <img src="./assets/img/images/icon-check-circle-green-acmic.svg"  alt="check filled icon" />
          </ng-container>
          <ng-template #maIcon>
            <img src="./assets/img/images/check-filled.svg"  alt="check filled icon" />
          </ng-template>
          Convenient 24/7
          access to your insurance documents online.
        </li>
        <li>
          <ng-container *ngIf="isAcmic; else maIcon">
            <img src="./assets/img/images/icon-check-circle-green-acmic.svg"  alt="check filled icon" />
          </ng-container>
          <ng-template #maIcon>
            <img src="./assets/img/images/check-filled.svg"  alt="check filled icon" />
          </ng-template>All your documents
          organized for each policy.
        </li>
        <li>
          <ng-container *ngIf="isAcmic; else maIcon">
            <img src="./assets/img/images/icon-check-circle-green-acmic.svg"  alt="check filled icon" />
          </ng-container>
          <ng-template #maIcon>
            <img src="./assets/img/images/check-filled.svg"  alt="check filled icon" />
          </ng-template>Filter your
          documents to review renewals, bills, payments and more.
        </li>
        <li>
          <ng-container *ngIf="isAcmic; else maIcon">
            <img src="./assets/img/images/icon-check-circle-green-acmic.svg"  alt="check filled icon" />
          </ng-container>
          <ng-template #maIcon>
            <img src="./assets/img/images/check-filled.svg"  alt="check filled icon" />
          </ng-template>Reduction of paper
          usage – Better for the environment!
        </li>
      </ul>
    </div>
    <hr class="margin-bottom marginLRinTab mb24 no-margin-top" />
    <div class="p-footer">
      <button class="not-now" (click)="hideOnClick()">Not now</button>
      <button class="enroll" (click)="enrollInPaperless()">
        Enroll in paperless
      </button>
    </div>
  </div>
</mapfre-modal>
